
import React, { PropTypes } from 'react';

export class Bullhorn extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    classes: PropTypes.string
  };

  getFillColor () {
    switch (this.props.colorSchema) {
      case 'primary':
        return '#00587c';
      case 'green-profile':
        return '#53AD99';
      case 'white':
        return '#ffffff';
      default:
        return '#34A8C5';
    }
  }

  getSecondaryFillColor () {
    switch (this.props.colorSchema) {
      case 'primary':
        return '#eff8fa';
      case 'green-profile':
        return '#beded6';
      case 'white':
        return '#d6d6d6';
      default:
        return '#b4dce7';
    }
  }

  render () {
    const fill = this.getFillColor();
    const secondaryFill = this.getSecondaryFillColor();

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width || '20'}
        height={this.props.height || '20'}
        viewBox="0 0 20 20"
        className={this.props.classes}
      >
        <path
          d="M0 7.5C0 6.12109 1.12109 5 2.5 5H7.5V12.5V13.75V18.75C7.5 19.4414 6.94141 20 6.25 20H3.75C3.05859 20 2.5
          19.4414 2.5 18.75V13.75C1.12109 13.75 0 12.6289 0 11.25V7.5ZM20 9.375C20 10.4648 19.4766 11.3906 18.75
          11.7344V7.01563C19.4766 7.35938 20 8.28516 20 9.375Z"
          fill={fill}
        ></path>
        <path
          d="M18.75 1.24998C18.75 0.746071 18.4453 0.28904 17.9766 0.0937273C17.5078 -0.101585 16.9727 0.00778983
          16.6133 0.363259L14.9102 2.07029C13.0352 3.94529 10.4922 4.99998 7.83984
          4.99998H7.5V6.24998V7.49998V11.25V12.5V13.75H7.83984C10.4922 13.75 13.0352 14.8047 14.9102 16.6797L16.6133
          18.3828C16.9727 18.7422 17.5078 18.8476 17.9766 18.6523C18.4453 18.457 18.75 18.0039 18.75 17.4961V1.24998Z"
          fill={secondaryFill}
        ></path>
      </svg>
    );
  }
}

export default Bullhorn;



/** WEBPACK FOOTER **
 ** ./src/components/svg/bullhorn.js
 **/